export const dealAccordionTranslations = {
    en: {
        headerTitle: "Dispute Deals",
        headerSubtitle: "Review dispute-related deals in one place",
        selectStatus: "Select status",
        fromDate: "From Date",
        toDate: "To Date",
        resetFilters: "Reset Filters",
        loading: "Loading deals...",
        emptyState: "No deals found",
        unknownUser: "Unknown User",
        loadingDetails: "Loading details...",
        pageLabel: "Page {{page}}",
        pageSize: "Page Size",
        previous: "Previous",
        next: "Next",
        errorFetch: "Failed to fetch deals",
        win: "Win",
        loss: "Loss",
        draw: "Draw",
        no_show_fault: "No Show (Fault)",
        no_show_medical: "No Show (Medical)",
        event_cancelled: "Event Cancelled",
        notSpecified: "Not Specified",
        yes: "Yes",
        no: "No",
        noSummaryData: "No summary data available",
    },
    de: {
        headerTitle: "Streitfälle",
        headerSubtitle: "Überprüfen Sie streitige Deals an einem Ort",
        selectStatus: "Status auswählen",
        fromDate: "Von Datum",
        toDate: "Bis Datum",
        resetFilters: "Filter zurücksetzen",
        loading: "Deals werden geladen...",
        emptyState: "Keine Deals gefunden",
        unknownUser: "Unbekannter Benutzer",
        loadingDetails: "Details werden geladen...",
        pageLabel: "Seite {{page}}",
        pageSize: "Seitengröße",
        previous: "Zurück",
        next: "Weiter",
        errorFetch: "Deals konnten nicht abgerufen werden",
        win: "Sieg",
        loss: "Niederlage",
        draw: "Unentschieden",
        no_show_fault: "Nicht erschienen (Schuld)",
        no_show_medical: "Nicht erschienen (Medizinisch)",
        event_cancelled: "Veranstaltung abgesagt",
        notSpecified: "Nicht angegeben",
        yes: "Ja",
        no: "Nein",
        noSummaryData: "Keine Zusammenfassungsdaten verfügbar",
    },
    hr: {
        headerTitle: "Sporni poslovi",
        headerSubtitle: "Pregledajte sporne poslove na jednom mjestu",
        selectStatus: "Odaberite status",
        fromDate: "Od datuma",
        toDate: "Do datuma",
        resetFilters: "Poništi filtere",
        loading: "Učitavanje poslova...",
        emptyState: "Nema pronađenih poslova",
        unknownUser: "Nepoznati korisnik",
        loadingDetails: "Učitavanje detalja...",
        pageLabel: "Stranica {{page}}",
        pageSize: "Veličina stranice",
        previous: "Prethodna",
        next: "Sljedeća",
        errorFetch: "Nije moguće dohvatiti poslove",
        win: "Pobjeda",
        loss: "Poraz",
        draw: "Neriješeno",
        no_show_fault: "Nedolazak (Krivnja)",
        no_show_medical: "Nedolazak (Medicinsko)",
        event_cancelled: "Događaj otkazan",
        notSpecified: "Nije navedeno",
        yes: "Da",
        no: "Ne",
        noSummaryData: "Nema dostupnih podataka sažetka",
    },
};
